export const COMMON_CODE_MAP = "COMMON_CODE_MAP";
export const COMMON_CODE_MAP_DETAIL = "COMMON_CODE_MAP_DETAIL";

export const TARGET_JUSO = "TARGET_JUSO";
export const AUTH_TOKEN = "AUTH_TOKEN";
export const USER_INFO = "USER_INFO";
export const OWNER_JUSO = "OWNER_JUSO";
// 공인중개사
export const AGT_PROPERTY_INQUIRY_STEP1 = "AGT_PROPERTY_INQUIRY_STEP1";
export const AGT_PROPERTY_INQUIRY_STEP2 = "AGT_PROPERTY_INQUIRY_STEP2";
export const AGT_PROPERTY_INQUIRY_STEP3 = "AGT_PROPERTY_INQUIRY_STEP3";

// 임대인
export const PROPERTY_INQUIRY_STEP1 = "PROPERTY_INQUIRY_STEP1";
export const PROPERTY_INQUIRY_STEP2 = "PROPERTY_INQUIRY_STEP2";
export const PROPERTY_INQUIRY_STEP3 = "PROPERTY_INQUIRY_STEP3";
export const PROPERTY_INQUIRY_STEP4 = "PROPERTY_INQUIRY_STEP4";

//for Clear
export const PROPERTY_CLEAR = "PROPERTY_CLEAR";
